export default __webpack_public_path__ + "static/media/faq.0953d3c6.jpg";